<template>
  <div class="chart-line-stacked">
    <div class="chart-line-stacked-canvas">
      <template v-for="part in values">
        <div
          v-if="part.value"
          :key="part.key"
          v-tooltip="tooltipOptions"
          :data-original-title="buildTooltip(part)"
          :class="`chart-line-stacked-canvas-${part.key}`"
          :style="buildStyles(part.value)"
          @mouseover="$emit('mouseover-bar')"
        />
      </template>
    </div>

    <div
      v-if="hasAxisLegend"
      class="chart-line-stacked-legend"
    >
      <span
        v-for="tick in legend"
        :key="tick"
        class="chart-line-stacked-legend-tick"
      >
        {{ tick }}%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppChartLineStacked',
  props: {
    values: {
      type: Array,
      required: true,
    },
    hasAxisLegend: {
      type: Boolean,
      default: true,
    },
    hasTooltips: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ html: true }),
  }),
  computed: {
    legend() {
      return [0, 25, 50, 75, 100];
    },
  },
  methods: {
    buildStyles(value) {
      return `width: ${value !== null ? value : 100}%`;
    },
    buildTooltip(part) {
      return this.hasTooltips ? part.tooltip : '';
    },
  },
};
</script>
